module.exports = __webpack_public_path__ + "static/media/astro_cane.00e4c6af.png";